import httpClient from "../utils/httpClient";

export const InsertWishlist = async (params) => {
    const response = await httpClient.post(`/Wishlist/InsertWishlist`, params);
    return response.data;
};

export const RemoveWishlist = async (params) => {
    const response = await httpClient.post(`/Wishlist/RemoveWishlist`, params);
    return response.data;
};

export const GetWishlistData = async (params) => {
    const response = await httpClient.post(`/Wishlist/GetWishlistData`, params || {});
    return response.data;
};

export const GetWishlistCount = async (params) => {
    const response = await httpClient.post(`/Wishlist/GetWishlistCount`, params || {});
    return response.data;
};
